import './index.css';

import { Provider } from 'mobx-react';
import React from 'react';
import ReactDOM from 'react-dom';

import Driver from './components/Driver/Driver';
import Widget from './components/Widget/Widget';
import getUrlVars from './lib/getUrlVars';
import { logInfo } from './lib/logging';
import RootStore from './stores/RootStore';

logInfo('url', { context: { url: window.location.href } });

const urlVars = getUrlVars();
const options = urlVars.opts ? JSON.parse(decodeURIComponent(urlVars.opts)) : {};
logInfo('options', { context: options });

const env = process.env.NODE_ENV;

let isCypress = false;

if (env === 'test') {
  isCypress = (window as any).Cypress || (window as any).parent.Cypress;
}

export const rootStore = new RootStore(options.apiKey);
const stores = {
  rootStore,
  identityStore: rootStore.identityStore,
  chatStore: isCypress ? rootStore.mockChatStore : rootStore.chatStore,
};

logInfo(JSON.stringify(process.env));

rootStore.readState().then(() => {
  switch (urlVars.as) {
    case 'widget':
      ReactDOM.render(
        <Provider {...stores}>
          <Widget options={options} />
        </Provider>,
        document.getElementById('root'),
      );
      break;
    default:
      ReactDOM.render(
        <Provider {...stores}>
          <Driver options={options} />
        </Provider>,
        document.getElementById('root'),
      );
  }
});
